import { render, staticRenderFns } from "./TabsDialog.vue?vue&type=template&id=7617d44a&scoped=true&"
import script from "./TabsDialog.vue?vue&type=script&lang=js&"
export * from "./TabsDialog.vue?vue&type=script&lang=js&"
import style0 from "./TabsDialog.vue?vue&type=style&index=0&id=7617d44a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7617d44a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7617d44a')) {
      api.createRecord('7617d44a', component.options)
    } else {
      api.reload('7617d44a', component.options)
    }
    module.hot.accept("./TabsDialog.vue?vue&type=template&id=7617d44a&scoped=true&", function () {
      api.rerender('7617d44a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/TabsDialog.vue"
export default component.exports